var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 67,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33 32.02A26.7 26.7 0 0 1 32 5.33a26.7 26.7 0 0 1 26.67 26.69A26.7 26.7 0 0 1 32 58.67 26.7 26.7 0 0 1 5.33 32.02Zm36.45 2.7c.28-.29.64-.73.72-.83a3.25 3.25 0 0 0-.05-3.88l-.2-.22c-.17-.18-.41-.45-.65-.68-2.11-2.27-7.62-5.97-10.5-7.1a8.76 8.76 0 0 0-2.14-.6c-.56 0-1.1.13-1.62.39-.64.36-1.16.93-1.44 1.6a17.2 17.2 0 0 0-.46 1.87A41.12 41.12 0 0 0 25 32c0 2.6.15 4.96.39 6.5l.06.3c.1.52.32 1.6.55 2.05a3.24 3.24 0 0 0 2.86 1.75h.1c.77-.03 2.4-.7 2.4-.72 2.73-1.13 8.1-4.66 10.27-7l.15-.16Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -4,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47097_465417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47097_465417",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayButton);
export default __webpack_public_path__ + "static/media/VideoPlayButton.733f8aad8d3cbfb2ef756caad71c56f6.svg";
export { ForwardRef as ReactComponent };